import type { FC } from 'react';

import type { ActiveDocMeta, NavTreeItem } from '@models/NavigationTree';
import { useNavigationItem } from '../../hooks/use-navigation-item';
import { ActiveNavItem } from '../../Navigation.styles';
import { NavLink } from '../NavLink/NavLink';
import { NavTree } from '../NavTree/NavTree';

export type NavTreeElementProps = { item: NavTreeItem; activeDocMeta: ActiveDocMeta };

export const NavTreeElement: FC<NavTreeElementProps> = ({ item, activeDocMeta }) => {
  const { isActive, isOpened, isParentTree, onDirectoryItemClickHandler } = useNavigationItem(item, activeDocMeta);

  return (
    <>
      <ActiveNavItem
        isActive={isActive}
        onClick={onDirectoryItemClickHandler}
        className={isParentTree ? 'active-parent' : ''}
      >
        <NavLink item={item} isOpened={isOpened} />
      </ActiveNavItem>
      {item.children?.length ? (
        <NavTree isOpened={isOpened} navTree={item.children} activeDocMeta={activeDocMeta} />
      ) : null}
    </>
  );
};
